var map = {
	"./Multinskie ozera.jpg": "7878",
	"./attach-file-rounded.svg": "92ea",
	"./close-rounded.svg": "75eb",
	"./content-copy-outline-rounded.svg": "99b7",
	"./content-paste-go-rounded.svg": "9259",
	"./delete-outline-rounded.svg": "c9b9",
	"./event-repeat-outline-rounded.svg": "c913",
	"./facebook_icon.svg": "8117",
	"./file-copy-alt (1).svg": "df81",
	"./file-copy-outline-rounded-blue.svg": "d59c",
	"./file-copy-outline-rounded.svg": "0607",
	"./flip-to-front.svg": "3865",
	"./hathayoga32-800x1080.jpg": "babe",
	"./instagram_icon.svg": "2fb5",
	"./keyboard-arrow-down-rounded.svg": "0c99",
	"./keyboard-arrow-up-rounded.svg": "bfbc",
	"./open-with-rounded.svg": "998d",
	"./push-pin-outline.svg": "d2bbb",
	"./share-outline.svg": "ec43",
	"./times-circle.svg": "adf6",
	"./twitter_icon.svg": "25c7",
	"./yoga.jpg": "5ef7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";